import http from "./http";


export const getAllBPointsGames = async () => {
  const res = await http.get("points_game/settle");
  return res.data;
};

/* ===============================
   GET SINGLE GAME DETAILS
================================ */
export const getBPointsGameDetails = async (id) => {
  const res = await http.get(
    `points_game/settle?id=${id}`
  );
  return res.data;
};

/* =========================================
   ✅ SETTLE B POINT GAME
========================================= */
export const settleBPointsGame = async (payload) => {
  const res = await http.post(
    "points_game/settle",
    payload,
    { headers: { "Content-Type": "application/json" } }
  );

  return res.data;
};